export class DTOCartelaPendente{ 
    Identificador: number; 
    PrimeiraCartela : string;
    SegundaCartela : string;
    DescPremiacao: string;
    TipoPremiacao: string;
    CnpjEmpresaVendedor: string;
    NomeEmpresaVendedor: string;
    CodRepresentante: number;
    NomeRepresentante: string; 
    DtRecebimento: string;

    deserialize(input: Object): DTOCartelaPendente {
        Object.assign(this, input);

        return this;
    }
}


// WEBPACK FOOTER //
// ./src/dto/dtoCartelaPendente.ts